<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style"; 
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import branch_officesAPI from "../../../services/branch_offices/branch_officesAPI";


/**
 * Basic Tables component
 */
export default {
  page: {
    title: "Sucursal",
    meta: [{ name: "description", content: appConfig.description }],


  },
  components: {
    Layout,
    Style,
    PageHeader,
  },
  data() {
    return {
      title: "Listado actas de reuniones comité copasst",
       items: [{
        text: 'Estándares',
        href: '/forms/estandares',
      },
      
      {
        text: 'Listado de actas de reuniones',
        active: true,
      },
      ],
       list: [],

       branchOfficeD: {
        name: null,
        address: null,
        company_id: null,
       
      }
    };
  },
  methods: {

   getList() {
      branch_officesAPI.getAllBranchOffice()
        .then((data) => {
          this.list = data.branch.data;
          console.log(data.branch.data)
        })
        .catch(error => {
          console.log(error)
        })
    },
    eliminar(id){
        branch_officesAPI.deleteBranchOffice(this.$route.params.id,{
        
      }).then((response) => {
        
          console.log(response);
      });
      	  },
    },

    mounted() {
    this.getList()
   
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-6">
            <h4 class="header-title">Modo de verificación <i class="mdi mdi-eye"></i></h4>
             </div>
             <div class="col-6 text-right m-b-0">
                        <router-link
                          to="/forms/acta-reunion"
                          class="btn btn-primary m-l-5 ml-1"
                          >Agregar</router-link
                        > 
                       
                    <router-link to="/forms/estandares" id="tooltip" class="btn btn-secondary m-l-5 ml-1"><i class="fas fa-arrow-left"></i></router-link>
                    <b-tooltip target="tooltip" placement="left"
                    >Volver</b-tooltip
                     >
                      </div>
                      </div>

            <div class="table-responsive">
              <table class="table mb-0 mt-2">
                <thead>
                  <tr class="text-center">
                   <!-- <th>Id</th>-->
                    <th>ID</th>
                    <th>Fecha</th>
                    <th>Descargar acta</th>
                  </tr>
                </thead>
                <tbody>
                
                  
                  <tr class="text-center" >
                     <!-- <th >{{ item.company_id }}</th>-->
                    <td>001</td>
                    <td>2022/12/01</td>
                    <td> <i class="mdi mdi-24px mdi-printer"></i>  </td>
                  </tr>
                   <tr class="text-center" >
                     <!-- <th >{{ item.company_id }}</th>-->
                    <td>002</td>
                    <td>2022/12/01</td>
                    <td> <i class="mdi mdi-24px mdi-printer"></i>  </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- end card -->
      </div>
     
    </div>
    <!--- end row -->


  </Layout>
</template>
